var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", width: "500" },
      on: {
        "click:outside": function($event) {
          return _vm.close()
        }
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pl-6 pr-2 pt-4 pb-0" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "warning" } },
                [_vm._v("mdi-alert")]
              ),
              _c("div", { staticClass: "title h6" }, [_vm._v(" Ad Fee Alert ")])
            ],
            1
          ),
          _c("v-container", { staticClass: "pa-0", attrs: { fluid: "" } }, [
            _c("div", { staticClass: "mx-6 my-2" }, [
              _c("p", [
                _vm._v("The ad fee on this promotion is "),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s("$" + _vm.promo.lump_sum_allowance))
                ])
              ]),
              _c("p", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.retailerWarning))
              ]),
              _vm.allowContinue
                ? _c("p", [_vm._v(" If not, please click continue. ")])
                : _vm._e()
            ]),
            _c(
              "div",
              { staticClass: "d-flex justify-center" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "mb-4 mr-4",
                    attrs: { text: "" },
                    on: { click: _vm.close }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.allowContinue ? "Cancel" : "Acknowledge") +
                        " "
                    )
                  ]
                ),
                _vm.allowContinue
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "mb-4",
                        attrs: { color: "warning" },
                        on: { click: _vm.submit }
                      },
                      [_vm._v(" Continue ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }